/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Portfolio
 */
export interface Portfolio {
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Portfolio
     */
    uwyear: number;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    description?: string | null;
    /**
     * 
     * @type {PortfolioPhaseEnum}
     * @memberof Portfolio
     */
    phase: PortfolioPhaseEnum;
    /**
     * 
     * @type {PortfolioPeriodEnum}
     * @memberof Portfolio
     */
    period?: PortfolioPeriodEnum | null;
    /**
     * 
     * @type {PortfolioStatusEnum}
     * @memberof Portfolio
     */
    status: PortfolioStatusEnum;
}


/**
 * @export
 */
export const PortfolioPhaseEnum = {
    Planning: 'Planning',
    Tiering: 'Tiering',
    Tracking: 'Tracking'
} as const;
export type PortfolioPhaseEnum = typeof PortfolioPhaseEnum[keyof typeof PortfolioPhaseEnum];

/**
 * @export
 */
export const PortfolioPeriodEnum = {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
    Hy: 'HY'
} as const;
export type PortfolioPeriodEnum = typeof PortfolioPeriodEnum[keyof typeof PortfolioPeriodEnum];

/**
 * @export
 */
export const PortfolioStatusEnum = {
    Draft: 'Draft',
    Active: 'Active',
    Closed: 'Closed'
} as const;
export type PortfolioStatusEnum = typeof PortfolioStatusEnum[keyof typeof PortfolioStatusEnum];


/**
 * Check if a given object implements the Portfolio interface.
 */
export function instanceOfPortfolio(value: object): value is Portfolio {
    if (!('uwyear' in value) || value['uwyear'] === undefined) return false;
    if (!('phase' in value) || value['phase'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PortfolioFromJSON(json: any): Portfolio {
    return PortfolioFromJSONTyped(json, false);
}

export function PortfolioFromJSONTyped(json: any, ignoreDiscriminator: boolean): Portfolio {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uwyear': json['uwyear'],
        'description': json['description'] == null ? undefined : json['description'],
        'phase': json['phase'],
        'period': json['period'] == null ? undefined : json['period'],
        'status': json['status'],
    };
}

export function PortfolioToJSON(json: any): Portfolio {
    return PortfolioToJSONTyped(json, false);
}

export function PortfolioToJSONTyped(value?: Portfolio | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uwyear': value['uwyear'],
        'description': value['description'],
        'phase': value['phase'],
        'period': value['period'],
        'status': value['status'],
    };
}

